import billingService from "../api/server/billingService";
import moment from "moment";
export const BILLING_NAMESPACE = "billingModule";

var fakeService;
const loadFakeService = async () => {
  if (fakeService) return fakeService;
  return import(
    `../api/${process.env.VUE_APP_SERVICE_FOLDER}/billingService`
  ).then(x => {
    fakeService = x.default;
    return fakeService;
  });
};

var services = {
  api:
    (process.env.VUE_APP_SERVICE_FOLDER === "fakes" &&
      process.env.NODE_ENV === "development") ||
    process.env.NODE_ENV === "test"
      ? loadFakeService()
      : Promise.resolve(billingService)
};

const state = {
  loading: false,
  isConnected: false,
  pendingOrders: [],
  filteredOrders: [],
  filterCondition: null,
  connectUri: ""
};
const actions = {
  async FlagItem(context, data) {
    var api = await services.api;
    data.NeedsReview = !data.NeedsReview;
    return api.flagItem(data).then(function(value) {
      state.pendingOrders.forEach(x => {
        if (x.Id == value.Id) {
          x.Flag = value.Flag;
          x.NeedsReview = value.NeedsReview;
        }
      });
      return value;
    });
  },
  async GET_PENDING_ORDERS(context, data) {
    state.loading = true;
    var api = await services.api;
    return api.getPendingOrders().then(function(value) {
      state.loading = false;
      context.commit("GET_PENDING_ORDERS", value);
    });
  },
  FILTER_TO_BILLABLE(context, data) {
    context.commit("FILTER_TO_BILLABLE");
  },
  async LOAD_NOTES(context, data) {
    var api = await services.api;
    return api.getNotes(data);
  },
  async LOAD_NOTESINTERNAL(context, data) {
    const { packageId, noteType } = data;
    var api = await services.api;
    return api.getNotesInternal(packageId, noteType);
  },
  async CREATE_NOTESINTERNAL(context, data) {
    var api = await services.api;
    return api.createNotesInternal(data);
  },
  async SAVE_DO_NOT_BILL(context, data) {
    var api = await services.api;
    var original = context.state.filteredOrders.find(x => x.Id === data.Id);
    var savedObject = helpers.createSavedObject(original, data);

    return api.removeOrders([savedObject]).then(function(value) {
      context.commit("UPDATE_ORDER", {
        original: original,
        new: savedObject
      });
    });
  },
  async SAVE_APPROVED_MOVE(context, data) {
    var api = await services.api;
    var original = context.state.filteredOrders.find(x => x.Id === data.Id);
    
    var savedObject = helpers.createSavedObject(original, data);
    return api.saveApproval(savedObject).then(function(value) {
      context.commit("UPDATE_ORDER", {
        original: original,
        new: savedObject
      });
    });
  },
  async AUTO_APPROVE_ORDERS(context, data) {
    var api = await services.api;
    var approveItems = [];
    data.forEach(x => {
      var original = context.state.pendingOrders.find(
        y => x.Id === y.Id && x.Flag === 0
      );
      if (original) approveItems.push(helpers.createSavedObject(original, x));
    });
    return api.autoApproveOrders(approveItems).then(function(value) {
      return actions.GET_PENDING_ORDERS(context, data);
    });
  },
  async REMOVE_ORDERS(context, data) {
    var api = await services.api;
    var doNotBillItems = [];
    data.forEach(x => {
      var original = context.state.pendingOrders.find(
        y => x.Id === y.Id && x.Flag === 3
      );
      if (original) doNotBillItems.push(helpers.createSavedObject(original, x));
    });
    return api.removeOrders(doNotBillItems).then(function(value) {
      // -- then refresh
      return api.getPendingOrders().then(function(value) {
        context.commit("GET_PENDING_ORDERS", value);
      });
    });
  },
  APPLY_ORDER_FILTER(context, data) {
    context.commit("SET_LOADING", true);
    context.commit("APPLY_ORDER_FILTER", data);
  },
  async SEARCH_ORDERS(context, data) {
    state.loading = true;
    var api = await services.api;
    return api.searchOrders(data).then(function(value) {
      state.loading = false;
      context.commit("GET_SEARCHED_ORDERS", value);
    });
  },
  async CHECK_CONNECT(context) {
    var api = await services.api;
    return api.checkConnection().then(function(value) {
      context.commit("SET_CONNECTED", value);
    });
  }
};
const helpers = {
  createSavedObject(original, data) {
    return {
      Id: data.Id,
      BillingApproved: data.BillingApproved,
      DoNotBill: data.DoNotBill,
      CourierNetworkFee: data.CourierNetworkFee,
      DeliveredBy: data.DeliveredBy,
      DeliveredBy_o: original.DeliveredBy,
      CourierNetworkFee_o: original.CourierNetworkFee,
      CourierQuote: data.CourierQuote,
      CourierQuote_o: original.CourierQuote,
      CourierActual: data.CourierActual,
      CourierActual_o: original.CourierActual,
      ClientActual: data.ClientActual,
      ClientActual_o: original.ClientActual,
      ClientQuote: data.ClientQuote,
      ClientQuote_o: original.ClientQuote,
      BillingExplanation: data.BillingExplanation,
      BillingExplanation_o: original.BillingExplanation
    };
  }
};
const mutations = {
  SET_CONNECTED(storeState, data) {
    storeState.isConnected = data.isConnected;
    storeState.connectUri = data.connectUri;
  },
  FILTER_TO_BILLABLE(storeState, data) {
    storeState.filteredOrders = storeState.pendingOrders.filter(
      x =>
        /* istanbul ignore next */
        x.CourierActual != null &&
        x.CourierActual > 0 &&
        !x.BillingApproved &&
        moment(x.OrderDate).isBefore(moment(), "week")
    );
  },
  UPDATE_ORDER(storeState, data) {
    console.log(data)
    data.original.BillingApproved = data.new.BillingApproved;
    data.original.DoNotBill = data.new.DoNotBill;
    data.original.CourierQuote = data.new.CourierQuote;
    data.original.CourierActual = data.new.CourierActual;
    data.original.ClientActual = data.new.ClientActual;
    data.original.ClientQuote = data.new.ClientQuote;
    data.original.BillingExplanation = data.new.BillingExplanation;
    data.original.DeliveredBy = data.new.DeliveredBy;
    data.original.CourierNetworkFee = data.new.CourierNetworkFee;
  },
  SET_LOADING(storeState, data) {
    storeState.loading = data;
  },
  async APPLY_ORDER_FILTER(storeState, data) {
    storeState.loading = true;
    if (data.data === -2) {
      
        storeState.filteredOrders = storeState.pendingOrders;
      
    } else 
    {
      if(data.selected == 5)
      {
        storeState.filteredOrders = storeState.searchedOrders
      }
      else{
        storeState.filteredOrders = storeState.pendingOrders.filter(
          x => x.Flag === data.data);
        }
    }
    storeState.loading = false;
  },
  GET_PENDING_ORDERS(storeState, data) {
    storeState.pendingOrders = data;
    storeState.filteredOrders = storeState.pendingOrders;
    storeState.loading = false;
  },
  GET_SEARCHED_ORDERS(storeState, data) {
    storeState.searchedOrders = data;
    storeState.filteredOrders = storeState.searchedOrders;
    storeState.loading = false;
  }
};
const getters = {
  loading: storeState => storeState.loading,
  isConnected: storeState => storeState.isConnected,
  connectUri: storeState => storeState.connectUri,
  pendingOrders: storeState => storeState.pendingOrders,
  searchedOrders: storeState => storeState.searchOrders,
  filteredOrders: storeState => storeState.filteredOrders,
  billableOrders: storeState =>
    storeState.pendingOrders.filter(
      x =>
        /* istanbul ignore next */
        x.CourierActual != null &&
        x.CourierActual > 0 &&
        !x.BillingApproved &&
        moment(x.OrderDate).isBefore(new Date(), "week")
    )
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  helpers,
  services
};
